import React from 'react'

export default function Footer() {
  return (
    <div className="container-fluid" style={{marginTop:'40px'}}>
    <footer className="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top ">
        <div className="col-md-4 d-flex align-items-center">
        <span className="mb-3 mb-md-0 text-muted">© 2024 AutoColorization, MinorProject</span>
        </div>
    </footer>
    </div>
  )
}
